import React from 'react';
import style from './style.module.scss';
import { icons } from '../../lib/helpers/icons';
import { AppIconType } from '../../lib/typegen/app-icon-type';
import { observer } from 'mobx-react-lite';
import { useStore } from '../../lib/hooks/useStore';
import logger from '../../lib/helpers/logger';

export interface NavigationButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
	innerText?: string | undefined;
	flow?: 'back' | 'next';
}

const NavigationButton = observer(function NavigationButton({
	type = 'button',
	flow,
	className,
	innerText,
	onClick,
	...props
}: NavigationButtonProps) {
	const {
		configStore: { getString },
	} = useStore();
	const buttonStyle = [className, style.button];
	if (flow === 'next') buttonStyle.push(style['button--next']);
	const Icon = icons[AppIconType.BlackArrowSolid];

	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		logger.logGeneral.log({}, `NavigationButton clicked [${innerText}]`, { flow });
		onClick?.(event);
	};

	return (
		<button {...props} type={type} onClick={handleClick} className={[...buttonStyle].join(' ')}>
			<Icon aria-hidden='true' className={style.button__icon} />
			<span className={style.button__text}>{getString(innerText)}</span>
		</button>
	);
});

export default NavigationButton;
